import HotelStatusIcon from 'components/HotelStatusIcon'
import moment from 'moment'
import { Link } from 'react-router-dom'

import { Cell, Row } from '../../../../components/ReusableComponents/Table'
import { formatPrice } from '../../../../utils/common'
import HotelIdCell from '../../Common/HotelIdCell'
import HotelNameCell from '../../Common/HotelNameCell'
import layoutStyles from '../Billing.module.scss'
import { healthCheckBillingInvoiceStatusLabels } from '../invoiceStatusNames'
import InvoicePipedriveLinkCell from '../InvoicePipedriveLinkCell'
import InvoicePromiseToPayCell from '../InvoicePromiseToPayCell'
import styles from './PMSBErow.module.scss'

const GoToBillingAndPayments = ({ subsidiaryId }) => {
  return (
    <Link to={`/s/${subsidiaryId}/billing`}>
      <button>Go to Billing &amp; Payments →</button>
    </Link>
  )
}

const BillingRow = ({
  displayId,
  brand,
  shortName,
  subsidiaryId,
  subsidiaryInvoiceId,
  index,
  subsidiaryStatus,
  rowStatus,
  statusExplanation,
  csmUserFullName,
  balanceState,
  invoiceDate,
  dueDate,
  agingDays,
  defaultPaymentMethod,
  totalAmountDue,
  balanceRemaining,
  invoiceBeginDate,
  invoiceEndDate,
  serviceBlockOn,
  promiseToPayDate
}) => {
  const invoiceLabel = `${moment(invoiceBeginDate).format('MMM DD')} - ${moment(invoiceEndDate).format('MMM DD, YYYY')}`

  const rowStatusClass =
    rowStatus === 'alert'
      ? layoutStyles.billingRowStatusAlert
      : rowStatus === 'warning'
        ? layoutStyles.billingRowStatusWarning
        : rowStatus === 'green'
          ? layoutStyles.billingRowStatusGreen
          : ''

  return (
    <div
      className={`${layoutStyles.billingRowWrapper} ${rowStatusClass}`}
      title={statusExplanation}
    >
      <Row className={layoutStyles.billingGridRowBody}>
        <Cell className={styles.statusCell}>
          <HotelStatusIcon status={subsidiaryStatus} />
        </Cell>
        <Cell className={styles.indexCell}>{index}</Cell>
        <HotelIdCell displayId={displayId} />
        <HotelNameCell
          className={layoutStyles.billingStackedCell}
          brand={brand}
          name={shortName}
          navigationControl={<GoToBillingAndPayments subsidiaryId={subsidiaryId} />}
          serviceBlockOn={serviceBlockOn}
        />
        <Cell className={styles.textCell}>
          <span title={csmUserFullName}>
            {csmUserFullName
              ?.split(' ')
              .map(str => str[0])
              .join('.')}
          </span>
        </Cell>
        <Cell className={`${styles.textCell} ${styles.invoiceCell} ${layoutStyles.billingStackedCell}`}>
          <span className={styles.invoiceId}>#{subsidiaryInvoiceId}</span>
          <span className={styles.invoicePeriod}>{invoiceLabel}</span>
        </Cell>
        <Cell className={styles.textCell}>
          {healthCheckBillingInvoiceStatusLabels[balanceState] || balanceState}
        </Cell>
        <Cell className={styles.textCell}>
          {invoiceDate ? moment(invoiceDate).format('MMM DD, YYYY') : '-'}
        </Cell>
        <Cell className={styles.textCell}>{moment(dueDate).format('MMM DD, YYYY')}</Cell>
        <Cell className={styles.textCell}>
          <span className={agingDays > 0 ? styles.overdueAging : styles.futureAging}>
            {agingDays}
          </span>
        </Cell>
        <Cell className={styles.textCell}>{defaultPaymentMethod || '-'}</Cell>
        <Cell className={styles.textCell}>{formatPrice(totalAmountDue)}</Cell>
        <Cell className={styles.textCell}>{formatPrice(balanceRemaining)}</Cell>
        <InvoicePromiseToPayCell
          subsidiaryId={subsidiaryId}
          subsidiaryInvoiceId={subsidiaryInvoiceId}
          promiseToPayDate={promiseToPayDate}
        />
        <InvoicePipedriveLinkCell displayId={displayId} />
      </Row>
    </div>
  )
}

export default BillingRow
